
<app-scroll-into-view class="scroll-into-view" id="top"></app-scroll-into-view>

<main-nav></main-nav>

<app-screen></app-screen>

<main 
  #main
  class="main-outlet" 
  appScroll
  [@routeAnimation]="(routeAnimationParams$ | push)"
  (@routeAnimation.start)="onAnimationStartEvent($event)"
  (@routeAnimation.done)="onAnimationDoneEvent($event)"
  >
  <router-outlet></router-outlet>
</main>

<!-- <app-page-bottom></app-page-bottom> -->

<!-- <app-page-bottom [@footerAnimation]="(hideFooter$ | push)" (@footerAnimation.done)="onFooterAnimationDoneEvent($event)" ></app-page-bottom>  -->